import { Link } from "react-router-dom";
import type { MediaItem } from "@/mocks/media";
import { formatRating, typeLabel } from "@/utils/format";

interface MovieCardProps {
  item: MediaItem;
}

export default function MovieCard({ item }: MovieCardProps) {
  return (
    <Link
      to={`/detail/${item.id}`}
      className="group block rounded-lg overflow-hidden bg-background-100 border border-background-300 hover:border-primary-400 transition-colors cursor-pointer"
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden bg-background-200">
        <img
          src={item.poster}
          alt={`${item.title} 海报`}
          title={`${item.title} - ${typeLabel(item.type)}`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <span className="absolute top-2 left-2 px-2 py-0.5 rounded-md text-[11px] font-medium bg-primary-500 text-background-50">
          {typeLabel(item.type)}
        </span>
        <span className="absolute top-2 right-2 flex items-center gap-0.5 px-1.5 py-0.5 rounded-md text-[11px] font-semibold bg-background-50/80 text-primary-400">
          <i className="ri-star-fill text-[10px]"></i>
          {formatRating(item.rating)}
        </span>
        <div className="absolute inset-x-0 bottom-0 h-16 bg-gradient-to-t from-background-50/90 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end justify-center pb-2">
          <span className="text-xs text-foreground-950 flex items-center gap-1">
            <i className="ri-play-circle-fill text-primary-400"></i>
            查看详情
          </span>
        </div>
      </div>
      <div className="p-2.5">
        <h3 className="text-sm font-medium text-foreground-950 truncate group-hover:text-primary-400 transition-colors">
          {item.title}
        </h3>
        <div className="mt-1.5 flex items-center gap-1.5 text-xs text-foreground-500">
          <span>{item.year}</span>
          <span className="w-px h-3 bg-background-400"></span>
          <span className="truncate">{item.genres.slice(0, 2).join(" · ")}</span>
        </div>
      </div>
    </Link>
  );
}